import { useEffect } from "react";
import { NetworkTypesList } from "../list/list";
import { logEvent } from "@shared/analytics/analytics";

export function NetworkManagementLanding() {
  useEffect(() => {
    logEvent("network_management_landing_viewed");
  }, []);
  return (
    <div className="p-2 space-y-6">
      <div>
        <p className="page-title">Network Management</p>
        <p className="page-subtitle">
          Manage network types and their descriptions for your water utility
          system.
        </p>
      </div>
      <NetworkTypesList />
    </div>
  );
}
